import { createIcon } from "@chakra-ui/react";

export const Home = createIcon({
  displayName: "Home",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#hhvqarnnxa)">
      <path
        fill="currentColor"
        d="M12.645 2.234a1.015 1.015 0 0 0-1.296 0l-11 9.187a.976.976 0 0 0-.116 1.387c.354.414.987.463 1.408.114l1.025-.853v7.65C2.666 21.532 4.158 23 6 23h12c1.842 0 3.334-1.468 3.334-3.281v-7.65l1.02.853c.421.353 1.055.3 1.409-.114a.975.975 0 0 0-.117-1.387l-11-9.187zM4.666 19.719V10.4L12 4.276l7.334 6.124v9.319c0 .726-.596 1.312-1.334 1.312h-2v-6.234c0-.907-.745-1.64-1.666-1.64H9.666c-.92 0-1.667.733-1.667 1.64v6.234H6a1.322 1.322 0 0 1-1.333-1.312zM10 21.03v-5.906h4v5.906h-4z"
      />
    </g>,
    <defs>
      <clipPath id="hhvqarnnxa">
        <path fill="#fff" transform="matrix(1 0 0 -1 0 24)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "A house icon"
  }
});

export default Home;
